class ctxTableTreeviewChildrenDirective {
    constructor() {
        this.restrict = 'AE';
        this.require = '^ctxTableTreeviewNode';
    }

    static directiveFactory() {
        return new ctxTableTreeviewChildrenDirective();
    }
}

ctxTableTreeviewChildrenDirective.directiveFactory.$inject = [];

module.exports = ctxTableTreeviewChildrenDirective.directiveFactory;


// WEBPACK FOOTER //
// ./src/shared/ctxTableTree/customDirectives/ctxTableTreeviewChildren.directive.js